import { useTranslation } from 'react-i18next';

export const NewBadge = () => {
  const { t } = useTranslation();
  return (
    <span className="rounded-md bg-chart-6 px-1.5 py-[2px] text-xs font-semibold leading-none text-chart-1">
      {t('global.new')}
    </span>
  );
};
